import { TrackEvent } from "./types";

interface QueueOpts {
  host: string;
  key: string;
  flushAt?: number;       // default 10
  flushIntervalMs?: number; // default 2000
  maxLocalStorageQueue?: number; // default 100
}

const LS_KEY = "_sx_queue";

export class EventQueue {
  private buf: TrackEvent[] = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private timer: any;
  private opts: Required<QueueOpts>;

  constructor(opts: QueueOpts) {
    this.opts = {
      flushAt: 10,
      flushIntervalMs: 2000,
      maxLocalStorageQueue: 100,
      ...opts,
    };
    this.drainLocalStorage();
  }

  push(ev: TrackEvent) {
    this.buf.push(ev);
    if (this.buf.length >= this.opts.flushAt) {
      this.flush(false);
    } else {
      this.scheduleFlush();
    }
  }

  flush(useBeacon: boolean) {
    if (this.buf.length === 0) return;
    const batch = this.buf;
    this.buf = [];
    clearTimeout(this.timer); this.timer = null;

    const body = JSON.stringify({ projectKey: this.opts.key, events: batch });
    const url = `${this.opts.host}/api/collect`;

    if (useBeacon && navigator.sendBeacon) {
      const ok = navigator.sendBeacon(url, body);
      if (!ok) this.persistToLocalStorage(batch);
      return;
    }

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
      credentials: "omit",
    }).catch(() => this.persistToLocalStorage(batch));
  }

  private scheduleFlush() {
    if (this.timer) return;
    this.timer = setTimeout(() => this.flush(false), this.opts.flushIntervalMs);
  }

  private persistToLocalStorage(batch: TrackEvent[]) {
    try {
      const existing: TrackEvent[] = JSON.parse(localStorage.getItem(LS_KEY) ?? "[]");
      const merged = [...existing, ...batch].slice(-this.opts.maxLocalStorageQueue);
      localStorage.setItem(LS_KEY, JSON.stringify(merged));
    } catch {}
  }

  private drainLocalStorage() {
    try {
      const raw = localStorage.getItem(LS_KEY);
      if (!raw) return;
      const batch: TrackEvent[] = JSON.parse(raw);
      localStorage.removeItem(LS_KEY);
      if (batch.length) this.buf.push(...batch);
    } catch {}
  }
}
